// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Transactions/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Ledger_New_Content_Transactions(
  $where_transactions: vaxiom_transactions_bool_exp!
  $where_payment_transactions: vaxiom_transactions_bool_exp!
  $where_payments: vaxiom_payments_bool_exp!
  $patient_id: numeric!
  $patient_person_id: numeric!
) {
  transactions: vaxiom_transactions(where: $where_transactions) {
    id
    dtype
    sys_created
    sys_created_by
    effective_date
    amount
    notes
    receivable_id
    created_by_user {
      id
      person {
        id
        first_name
        last_name
      }
    }
    misc_fee_charge {
      id
      name
    }
    retail_fee {
      id
      retail_item {
        id
        name
      }
    }
    discount_adjustment {
      id
      discount_adjustment_type
      discount {
        id
        name
      }
      discount_reverse_adjustments {
        id
        discount_adjustment_id
      }
    }
    installment_charge {
      id
      payment_plan_id
    }
    payment_plan {
      id
      payment_plan_rollback_id
      rollback_date
    }
    payment_plan_rollback {
      id
    }
    charge_transfer_adjustment {
      id
      transfer_charge_type
      transfer_charge {
        id
        transfer_charge_type
        charge_transfer_adjustment_id
        transaction {
          id
          receivable {
            id
            human_readable_id
            patient {
              id
              person {
                id
                first_name
                last_name
              }
            }
            payment_account {
              id
              account_type
              person_payment_account {
                id
                payer_person {
                  id
                  first_name
                  last_name
                  from_person_relationships(
                    where: { to_person: { _eq: $patient_person_id } }
                  ) {
                    id
                    type
                    role
                  }
                  patient {
                    id
                    _id
                  }
                }
              }
              insurance_payment_account {
                id
                insurance_company {
                  id
                  carrier_name
                }
              }
            }
          }
        }
      }
    }
    transfer_charge {
      id
      transfer_charge_type
      charge_transfer_adjustment_id
      charge_transfer_adjustment {
        id
        transfer_charge_type
        transaction {
          id
          receivable {
            id
            human_readable_id
            patient {
              id
              person {
                id
                first_name
                last_name
              }
            }
            payment_account {
              id
              account_type
              person_payment_account {
                id
                payer_person {
                  id
                  first_name
                  last_name
                  from_person_relationships(
                    where: { to_person: { _eq: $patient_person_id } }
                  ) {
                    id
                    type
                    role
                  }
                  patient {
                    id
                    _id
                  }
                }
              }
              insurance_payment_account {
                id
                insurance_company {
                  id
                  carrier_name
                }
              }
            }
          }
        }
      }
    }
    applied_payment {
      id
      applied_type
      unapplied_payment {
        id
        transaction {
          id
          sys_created
          sys_created_by
          notes
          created_by_user {
            id
            person {
              id
              first_name
              last_name
            }
          }
        }
      }
      payment {
        id
        payment_type
        check_number
        last_four_digits
        transaction_id
        payer_name
        type_info
        notes
        sys_created
        source
        human_readable_id
        account {
          id
          account_type
          person_payment_account {
            id
            payer_person {
              id
              first_name
              last_name
              from_person_relationships(
                where: { to_person: { _eq: $patient_person_id } }
              ) {
                id
                type
                role
              }
              patient {
                id
                _id
              }
            }
          }
          insurance_payment_account {
            id
            insurance_company {
              id
              carrier_name
            }
          }
        }
        payment_type_record {
          id
          name
        }
        organization {
          id
          name
        }
      }
    }
    unapplied_payment {
      id
      applied_payment {
        id
        applied_type
        payment {
          id
          payment_type
          check_number
          last_four_digits
          transaction_id
          payer_name
          type_info
          notes
          sys_created
          human_readable_id
          source
          account {
            id
            account_type
            person_payment_account {
              id
              payer_person {
                id
                first_name
                last_name
                from_person_relationships(
                  where: { to_person: { _eq: $patient_person_id } }
                ) {
                  id
                  type
                  role
                }
                patient {
                  id
                  _id
                }
              }
            }
            insurance_payment_account {
              id
              insurance_company {
                id
                carrier_name
              }
            }
          }
          payment_type_record {
            id
            name
          }
        }
      }
    }
    refund {
      id
      refund_type
    }
    receivable {
      id
      due_date
      human_readable_id
      payment_account {
        id
        account_type
        person_payment_account {
          id
          payer_person {
            id
            first_name
            last_name
          }
        }
        insurance_payment_account {
          id
          insurance_company {
            id
            carrier_name
          }
        }
      }
      organization {
        id
        name
      }
    }
  }
  payment_transactions: vaxiom_transactions(
    where: $where_payment_transactions
  ) {
    id
    dtype
    sys_created
    sys_created_by
    effective_date
    amount
    notes
    receivable_id
    created_by_user {
      id
      person {
        id
        first_name
        last_name
      }
    }
    applied_payment {
      id
      applied_type
      unapplied_payment {
        id
        transaction {
          id
          sys_created
          sys_created_by
          notes
          created_by_user {
            id
            person {
              id
              first_name
              last_name
            }
          }
        }
      }
      payment {
        id
        payment_type
        check_number
        last_four_digits
        transaction_id
        payer_name
        type_info
        notes
        sys_created
        source
        human_readable_id
        account {
          id
          account_type
          person_payment_account {
            id
            payer_person {
              id
              first_name
              last_name
              from_person_relationships(
                where: { to_person: { _eq: $patient_person_id } }
              ) {
                id
                type
                role
              }
              patient {
                id
                _id
              }
            }
          }
          insurance_payment_account {
            id
            insurance_company {
              id
              carrier_name
            }
          }
        }
        payment_type_record {
          id
          name
        }
        organization {
          id
          name
        }
      }
      # payment the credit was transferred to
      payments {
        id
        human_readable_id
        account {
          id
          account_type
          person_payment_account {
            id
            payer_person {
              id
              first_name
              last_name
              from_person_relationships(
                where: { to_person: { _eq: $patient_person_id } }
              ) {
                id
                type
                role
              }
              patient {
                id
                _id
              }
            }
          }
          insurance_payment_account {
            id
            insurance_company {
              id
              carrier_name
            }
          }
        }
      }
    }
  }
  notes: vaxiom_notes(
    where: {
      target_id: { _eq: $patient_id }
      target_type: { _eq: "Patient.Ledger" }
    }
  ) {
    id
    _id
    notes: note
    target_type
    sys_created
    author
    author_user {
      id
      person {
        id
        first_name
        last_name
      }
    }
  }
  payments: vaxiom_payments(where: $where_payments) {
    id
    payment_type
    amount
    check_number
    last_four_digits
    transaction_id
    payer_name
    type_info
    sys_created
    sys_created_by
    source
    notes
    created_by_user {
      id
      person {
        id
        first_name
        last_name
      }
    }
    account {
      id
      account_type
      person_payment_account {
        id
        payer_person {
          id
          first_name
          last_name
          from_person_relationships(
            where: { to_person: { _eq: $patient_person_id } }
          ) {
            id
            type
            role
          }
          patient {
            id
            _id
          }
        }
      }
      insurance_payment_account {
        id
        insurance_company {
          id
          carrier_name
        }
      }
    }
    organization {
      id
      name
    }
  }
}

`